'use client';

import type { ComponentProps } from 'react';
import { Toaster as RHTToaster, type ToastPosition } from 'react-hot-toast';

const TOAST_POSITION: ToastPosition = 'top-center';
const TOAST_DURATION = 5000;

export const Toaster = (options?: ComponentProps<typeof RHTToaster>) => (
  <RHTToaster
    position={TOAST_POSITION}
    {...options}
    toastOptions={{ duration: TOAST_DURATION, ...options?.toastOptions }}
  />
);
